
<div
  ref="conteneurImg"
  class="d-flex flex-column focal-point h-100"
  :class="jel_getClassObject(content)"
>
  <b-img-lazy
    :src="jel_getImageSrcFocalPoint(content.image, content.formatRatio, largeur)"
    :alt="content.altImage ? content.altImage : ''"
    :show="show"
    :class="getImageSize"
    :onload="setIsLoaded()"
  />
</div>
